// Разбор ошибки запроса для показа в форме чекаута (docs/09-code-standards.md §8:
// та же логика уже есть в frontend/admin/src/lib/formError.ts — здесь свой
// экземпляр, потому что фронты витрины и админки отдельные приложения).
import { ApiError } from "../api/client";

/** FormError — ошибка запроса в том виде, в каком её показывает форма. */
export interface FormError {
  /** Общий текст рядом с формой. null — показывать нечего. */
  message: string | null;
  /** Сообщения по полям из error.fields ответа 422 (docs/04-api-contract.md §1). */
  fields: Readonly<Record<string, string>>;
}

const EMPTY: FormError = { message: null, fields: {} };

/**
 * formError разбирает ошибку мутации для показа в форме.
 *
 * 401 и 5xx — сеть/сервер восстанавливает apiRequest или показывает общий экран
 * ошибки выше по дереву; форма о них молчит, иначе покупатель увидел бы два
 * сообщения об одном сбое. Когда есть ошибки полей, общий текст тоже
 * не показываем — он их повторяет.
 */
export function formError(error: unknown): FormError {
  if (!(error instanceof ApiError)) {
    return EMPTY;
  }
  const handledGlobally = error.status === 0 || error.status === 401 || error.status >= 500;
  if (handledGlobally) {
    return { message: null, fields: error.fields };
  }
  const hasFields = Object.keys(error.fields).length > 0;
  return { message: hasFields ? null : error.message, fields: error.fields };
}
